// Constants for type identification
export const TYPES = {
  HOME_LOANS: "Home Loans",
  COMMERCIAL_BANKING: "Commercial Banking",
  COMMERCIAL_FINANCING: "Commercial Financing",
  NONPROFIT_BANKING: "Non-profit Banking",
  NONPROFIT_FINANCING: "Non-profit Financing",
  PERSONAL_BANKING: "Personal Banking"
};

// Lender data arrays
export const NONPROFIT_BANKING = [
/*  {
    id: "Stearns-Bank-3",
    name: "Stearns Bank",
    product: "Salaam Nonprofit Banking Solutions",
    description: "Salaam Nonprofit Banking Solutions is an interest-free account where nonprofit organizations like schools and mosques can earn interest-free returns on their deposits.",
    details: "Nonprofit organizations like schools and mosques can finally start to earn interest-free returns on their deposits through the Salaam Nonprofit Savings Account. We offer profit sharing with an expected profit derived from Stearns Bank's Islamic Banking financing portfolio. Our Salaam Nonprofit Checking Account is perfect for operational needs like accepting donations, paying utility bills, and payroll. All of our Salaam Nonprofit accounts are interest-free and we offer customized solutions to extend FDIC insurance beyond $250,000.",
    applyUrl: "https://oao.stearnsbank.com/business"
  },*/
];

export const NONPROFIT_FINANCING = [
  {
    id: "Craft3-Nonprofit-1",
    name: "Craft3: Community Crafted Lending",
    product: "Shariah-Compliant Financing",
    description: "To better serve the growing Muslim community in the Pacific Northwest, Craft3, in collaboration with key partners, has developed Shariah-compliant financing solutions.",
    details: "Muslims who seek to live in accordance with Shariah principles are unable to access conventional debt capital because of Islam's prohibition against charging or paying interest. To better serve the growing Muslim community in the Pacific Northwest, Craft3 has worked with key partners to develop Shariah-compliant financing.",
    applyUrl: "https://www.craft3.org/business-loans/sharia-financing"
  },
];

export const COMMERCIAL_FINANCING = [
  {
    id: "Craft3-1",
    name: "Craft3: Community Crafted Lending",
    product: "Shariah-Compliant Financing",
    description: "To better serve the growing Muslim community in the Pacific Northwest, Craft3, in collaboration with key partners, has developed Shariah-compliant financing solutions.",
    details: "Muslims who seek to live in accordance with Shariah principles are unable to access conventional debt capital because of Islam's prohibition against charging or paying interest. To better serve the growing Muslim community in the Pacific Northwest, Craft3 has worked with key partners to develop Shariah-compliant financing.",
    applyUrl: "https://www.craft3.org/business-loans/sharia-financing"
  },
];

export const COMMERCIAL_BANKING = [
/*  {
    id: "Stearns-Bank-4",
    name: "Stearns Bank",
    product: "Salaam Business Checking",
    description: "The Salaam Checking Account is an interest-free account that can help you meet your day-to-day business banking needs.",
    details: "The Salaam Checking Account has no minimum balance requirement and no maintenance fees. It also includes waived fees on up to five international wire transfers per month so you can pay your clients internationally effortlessly.",
    applyUrl: "https://oao.stearnsbank.com/business"
  },
  {
    id: "Stearns-Bank-5",
    name: "Stearns Bank",
    product: "Salaam Business Market Savings",
    description: "Salaam Business Market Savings is an interest-free savings account that can help you earn interest-free profit-based returns on your deposits.",
    details: "Earn interest-free profit-based returns on your deposits through Stearns Bank's Salaam Savings Account. We offer profit sharing with an expected profit derived from Stearns Bank's Islamic Banking Division financing portfolio. Your funds are not invested in interest-bearing instruments and are kept separate from interest-bearing deposits. Stearns Bank also offers customized solutions to extend FDIC insurance well beyond the $250,000 limit so that your funds remain secure.",
    applyUrl: "https://oao.stearnsbank.com/business"
  }*/
];

export const HOME_LOANS = [
  {
    id: "Guidance-Residential-1",
    name: "Guidance Residential",
    product: "Home Financing Options",
    description: "Guidance Residential specializes in Shariah-compliant home financing in the U.S.",
    details: "Guidance Residential specializes in Shariah-compliant home financing in the U.S. Our unique Declining Balance Co-ownership Program was created under the guidance of seven globally renowned Shariah scholars and eighteen U.S. law firms to ensure it meets strict adherence to legal jurisprudence of the Islamic faith and conforms to U.S. legal and regulatory requirements.",
    applyUrl: "https://www.guidanceresidential.com/islamic-home-finance-options"
  },
  {
    id: "uif-1",
    name: "UIF",
    product: "Home Financing",
    description: "UIF offers home financing programs that can be used to purchase a new home or refinance an existing one.",
    details: "UIF offers home financing programs that can be used to purchase a new home or refinance an existing one. UIF's programs adhere to Faith-Based financing principles and are fully approved by an independent Sharia Supervisory Board. Equally important, it's pricing is very competitive when you compare UIF to conventional lenders or other Faith-Based financing companies.",
    applyUrl: "https://www.myuif.com/get-started/"
  }
];

export const PERSONAL_BANKING = [
/*  {
    id: "Stearns-Bank-1",
    name: "Stearns Bank",
    product: "Salaam Personal Checking",
    description: "The Salaam Checking Account is an interest-free account that can help with your day-to-day banking needs.",
    details: "The Salaam Personal Checking Account has no minimum balance requirement and no maintenance fees. It also includes waived fees on up to three international wire transfers per month so you can effortlessly pay your family members and friends internationally.",
    applyUrl: "https://oao.stearnsbank.com/personal"
  },
  {
    id: "Stearns-Bank-2",
    name: "Stearns Bank",
    product: "Salaam Personal Market Savings",
    description: "Salaam Personal Market Savings is an interest-free savings account that can help you earn interest-free profit-based returns on your deposits.",
    details: "Earn interest-free profit-based returns on your deposits through Stearns Bank's Salaam Savings Account. We offer highly competitive profit-sharing rates with an expected profit derived from Stearns Bank's Islamic Banking financing portfolio. Your funds are not invested in interest-bearing instruments and are kept separate from interest-bearing deposits. Stearns Bank also offers customized solutions to extend FDIC insurance well beyond the $250,000 limit so that your funds remain secure.",
    applyUrl: "https://oao.stearnsbank.com/personal"
  }*/
];
